module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon-smile-e33343aae9075260781ec500680bf387.svg";